<template>
  <v-card flat height="100%" class="d-flex flex-column">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title class="subtitle-1">Create New Request</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="flex-grow-1 pt-6 px-6">
      <v-form ref="form" v-model="valid">
        <v-alert
          v-if="alert.message"
          :type="alert.status"
          dense
          text
          dismissible
        >
          {{ alert.message }}
        </v-alert>

        <div class="mb-6">
          <h3 class="headline font-weight-bold mb-2">
            What would you like to pay for?
          </h3>
          <p class="subtitle-2 grey--text text--darken-1">
            Select a service from the list below to generate a payment request.
          </p>
        </div>

        <v-autocomplete
          v-model="selectedService"
          :items="serviceTypes"
          item-text="Description"
          item-value="Charge_Item"
          label="Select Service/Charge Item"
          outlined
          placeholder="Start typing to search..."
          return-object
          :rules="[(v) => !!v || 'Please select a service to proceed']"
          prepend-inner-icon="mdi-magnify"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.Description }}</v-list-item-title>
              <v-list-item-subtitle class="primary--text font-weight-bold">
                {{ item.Amount | currency }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-expand-transition>
          <div v-if="selectedService" class="mt-4">
            <v-card color="grey lighten-4" flat class="rounded-lg">
              <v-card-text>
                <div class="d-flex justify-space-between align-center mb-2">
                  <span
                    class="caption grey--text text-uppercase font-weight-bold"
                    >Service Details</span
                  >
                  <v-chip x-small color="primary" label>{{
                    selectedService.Charge_Item
                  }}</v-chip>
                </div>
                <div class="subtitle-1 font-weight-bold black--text mb-4">
                  {{ selectedService.Description }}
                </div>

                <v-divider class="mb-4"></v-divider>

                <div class="d-flex justify-space-between align-end">
                  <div>
                    <div class="caption grey--text">Total Amount</div>
                    <div class="display-1 primary--text font-weight-bold">
                      {{ selectedService.Amount | currency }}
                    </div>
                  </div>
                  <div
                    class="text-right caption grey--text"
                    v-if="selectedService.VAT_Percent"
                  >
                    Includes {{ selectedService.VAT_Percent }}% VAT
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-alert type="info" text dense class="mt-4 caption">
              <v-icon x-small left color="info">mdi-information-outline</v-icon>
              Clicking "Confirm & Pay" will generate a formal request and open
              the secure payment gateway.
            </v-alert>
          </div>
        </v-expand-transition>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="pa-6">
      <v-btn text large @click="$emit('close')" :disabled="loading"
        >Cancel</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        large
        depressed
        :loading="loading"
        :disabled="!valid || !selectedService"
        @click="submit"
        class="px-8"
      >
        Confirm & Pay
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AuthService } from "../../auth";
import { appUrl } from "@/environment/environment";
import RouterMixin from "@/router/RouterMixin";

export default {
  name: "ServiceRequestDrawer",
  mixins: [RouterMixin],
  data: () => ({
    valid: false,
    selectedService: null,
  }),
  computed: {
    serviceTypes() {
      return this.$store.getters["Payments/serviceTypes"];
    },
    loading() {
      return this.$store.getters["Payments/loading"];
    },
    alert() {
      return this.$store.getters["Payments/alert"];
    },
    user() {
      return AuthService.user || {};
    },
    profile() {
      return this.user.profile || {};
    },
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        const payload = {
          memberNo: this.profile.MemberNo,
          profileID: this.profile.ProfileID,
          membershipCategory: this.profile.MemberShipType,
          serviceType: this.selectedService.Charge_Item,
          serviceDescription: this.selectedService.Description,
        };

        const result = await this.$store.dispatch(
          "Payments/createRequest",
          payload
        );

        if (result) {
          // Initiate payment immediately
          const data = Array.isArray(result) && result.length > 0 ? result[0] : result
          this.pay(data, this.selectedService);
          this.$emit("close");
          this.selectedService = null;
        }
      }
    },
    pay(data, charge) {
      const PhoneNo =
        this.profile.PhoneNo.charAt(0) === "+"
          ? this.profile.PhoneNo.slice(1)
          : this.profile.PhoneNo.charAt(0) === "0"
          ? `254${this.profile.PhoneNo.slice(1)}`
            : this.profile.PhoneNo;

      const isCert =
        (charge.Service_Request_Code || "").toLowerCase().includes("cert") ||
        (data.serviceDescription || "").toLowerCase().includes("cert");

      const successUrl = isCert
        ? new URL(
            this.$router.resolve({
              path: `/dashboard/membershipcertificate/${this.encodeRoute(
                this.profile.ProfileID
              )}`,
            }).href,
            appUrl
          )
        : new URL(this.$router.resolve({ name: "Payments" }).href, appUrl);

      let payload = {
        payerID: this.profile.ProfileID,
        sourceDocumentNo: data.no,
        serviceID: charge.Service_Request_Code,
        description: data.serviceDescription || "Service Request Payment",
        amount: data.amount || charge.Amount,
        accountNo: PhoneNo,
        email: this.user && this.user.email ? this.user.email : "",
        idNumber: this.profile.IdentificationDocumentNo,
        name: data.memberName,
        success_url: successUrl,
        fail_url: window.location.href,
      };
      console.log(payload)

      payload = btoa(JSON.stringify(payload));
      this.$checkout.pay(payload);
    },
  },
};
</script>
